class HeroParallax {
  constructor() {
    this.heroSections = document.querySelectorAll('.hero-animation')
    this.ticking = false

    // store bound handlers so add/removeEventListener use same reference
    this.onScroll = this.handleScroll.bind(this)
    this.onResize = this.handleResize.bind(this)

    this.init()
  }

  init() {
    if (this.heroSections.length === 0) return

    this.bindEvents()
    this.setupParallaxElements()
  }

  bindEvents() {
    window.addEventListener('scroll', this.onScroll, { passive: true })
    window.addEventListener('resize', this.onResize, { passive: true })
  }

  setupParallaxElements() {
    this.heroSections.forEach((section) => {
      const mediaWrapper = section.querySelector('.hero__media-wrapper')
      const images = section.querySelectorAll('.hero__image')
      const videos = section.querySelectorAll('.hero__video')

      if (mediaWrapper) {
        mediaWrapper.style.overflow = 'hidden'
        images.forEach((img) => this.wrapInParallaxContainer(img))
        videos.forEach((video) => this.wrapInParallaxContainer(video))
      }
    })
  }

  wrapInParallaxContainer(element) {
    if (element.closest('.parallax-container')) return

    const container = document.createElement('div')
    container.className = 'parallax-container'
    Object.assign(container.style, {
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      position: 'relative',
    })

    const parent = element.parentElement
    if (!parent) return
    parent.insertBefore(container, element)
    container.appendChild(element)

    // Preserve existing object-position if it exists
    const existingObjectPosition =
      element.style.objectPosition || getComputedStyle(element).objectPosition

    Object.assign(element.style, {
      width: '110%',
      height: '110%',
      objectFit: 'cover',
      objectPosition:
        existingObjectPosition !== 'initial' ? existingObjectPosition : 'center center',
      transformOrigin: 'center center',
      transition: 'transform 0.1s ease-out',
    })
  }

  handleScroll() {
    if (!this.ticking) {
      requestAnimationFrame(() => this.updateParallax())
      this.ticking = true
    }
  }

  handleResize() {
    this.updateParallax()
  }

  updateParallax() {
    const windowHeight = window.innerHeight

    this.heroSections.forEach((section) => {
      const rect = section.getBoundingClientRect()
      const sectionTop = rect.top
      const sectionBottom = rect.bottom
      const sectionHeight = rect.height

      if (sectionBottom > 0 && sectionTop < windowHeight) {
        const parallaxElements = section.querySelectorAll(
          '.parallax-container img, .parallax-container video'
        )

        parallaxElements.forEach((el) => {
          const scrollProgress = Math.max(
            0,
            Math.min(1, (windowHeight - sectionTop) / (windowHeight + sectionHeight))
          )

          const zoomScale = 1 + scrollProgress * 0.1
          const translateY = (scrollProgress - 0.5) * 20

          el.style.transform = `scale(${zoomScale}) translateY(${translateY}px)`
        })
      }
    })

    this.ticking = false
  }

  destroy() {
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.onResize)
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new HeroParallax()
})

document.addEventListener('shopify:section:load', () => {
  new HeroParallax()
})

document.addEventListener('shopify:section:unload', () => {
  // Clean up if needed
})
